import {call, put, take} from "redux-saga/effects";
import {ActionType} from "typesafe-actions";
import {ResponseType} from "../../api/util";
import {Action as NotifyAction} from "../../NotificationSystem";
import * as Action from "../actions";

type FlowAction = ActionType<typeof Action.Command.changeResponsibleTeam>

export function* changeResponsibleTeamFlow() {

    while (true) {
        const action: FlowAction = yield take([Action.Type.CHANGE_RESPONSIBLE_TEAM]);

        const {response, error}: ResponseType = yield call(Action.Api.changeResponsibleTeam, action.payload.board.uid, action.payload.board.responsibleTeam);

        if (error) {
            yield put(NotifyAction.Command.error('Request Error', 'Could not change responsible team.'));
            yield put(Action.Query.fetchUserBoards());
        }

        if(response) {
            yield put(NotifyAction.Command.info('Responsible team changed', ''));
        }
    }
}
